import script from "./NewLoginForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewLoginForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewLoginForm.vue?vue&type=style&index=0&id=03a74339&lang=css"

const __exports__ = script;

export default __exports__